import {Component, OnInit, ElementRef, EventEmitter, Output, Input, ViewChild} from '@angular/core';
import {FieldComponent} from "../field/field.component";

@Component({
  selector: 'taxihandgo-date',
  templateUrl: './date.component.html',
  styleUrls: ['./date.component.scss']
})
export class DateComponent implements OnInit {
  private _value: string;
  @Output() valueChange = new EventEmitter();
  @Input() now: boolean = false;
  @ViewChild("field") field: FieldComponent;
  constructor() { }

  ngOnInit() {
    this.field.valueChange.subscribe(value => {
      this.valueChange.emit(value);
    });
    let date = new Date();
    console.log(date);
    if (this.now){
      this.value = '' + (date.getUTCDate() < 10 ? '0' + date.getUTCDate() : date.getUTCDate())
          + (date.getUTCMonth() + 1 < 10 ? '0' + (date.getUTCMonth() + 1) : (date.getUTCMonth() + 1 ))
          + date.getFullYear()
      ;
      this.valueChange.emit(this.value);
    }
  }

  public onPaste(event: any){
    if (event.data && event.data.length != 8){return;}
    let reg = /[0-9]{2}[\/-][0-9]{2}[\/-][0-9]{4}/g;
    if (reg.test(event.dataSource)){
      this.value = event.data.substr(0, 2) + event.data.substr(2, 2) + event.data.substr(4, 4);
      return;
    }

    reg = /[0-9]{2}[\/-][0-9]{2}[\/-][0-9]{4}/g;
    if (reg.test(event.dataSource)){
      this.value = event.data;
      return;
    }

    reg = /[0-9]{4}[\/-][0-9]{2}[\/-][0-9]{2}/g;
    if (reg.test(event.dataSource)){
      this.value = event.data.substr(6, 2) + event.data.substr(4, 2) + event.data.substr(0, 4);
      return;
    }
    this.value = "";
  }

  @Input()
  get value() {
    return this._value;
  }

  set value(value: string){
    this._value = value;
  }
}



// WEBPACK FOOTER //
// ./src/app/date/date.component.ts